import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';
import { Project } from '../../../services/projects';
import { formatDate } from '../utils/formatters';

interface ProjectHeaderProps {
  project: Project;
  onDeleteProject: () => void;
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({ project, onDeleteProject }) => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom: '2rem',
      backgroundColor: 'white',
      padding: '1.5rem',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <div>
        <h2 style={{ fontSize: '1.8rem', fontWeight: 600, color: '#1e1e1e', marginBottom: '0.5rem' }}>
          {project.name}
        </h2>
        <p style={{ color: '#666', marginBottom: '0.5rem' }}>
          {project.location_details?.formatted_address ? 
            project.location_details.formatted_address : 
            !project.location ? 
              (project.address || 'No location specified') :
              typeof project.location === 'string' ? project.location : 
                (project.location?.address ? 
                  `${project.location.address}${project.location.city ? ', ' + project.location.city : ''}${project.location.state ? ', ' + project.location.state : ''}` 
                  : 'Location details incomplete')}
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ 
            padding: '0.25rem 0.5rem', 
            borderRadius: '4px',
            fontSize: '0.85rem',
            backgroundColor: 
              project.status === 'New' ? '#e6f7ff' : 
              project.status === 'Analyzed' ? '#f6ffed' : 
              '#fff7e6',
            color: 
              project.status === 'New' ? '#1890ff' : 
              project.status === 'Analyzed' ? '#52c41a' : 
              '#fa8c16'
          }}>
            {project.status}
          </span>
          <span style={{ color: '#666', fontSize: '0.9rem' }}>
            Last updated: {formatDate(project.lastUpdated)}
          </span>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <Button 
          onClick={() => navigate('/welcome')}
          style={{ 
            backgroundColor: 'white',
            color: '#1e1e1e',
            border: '1px solid #1e1e1e'
          }}
        >
          Back to Dashboard
        </Button>
        <Button 
          onClick={onDeleteProject}
          style={{ 
            backgroundColor: '#fff',
            color: '#ff4d4f',
            border: '1px solid #ff4d4f'
          }}
        >
          Delete Project
        </Button>
      </div>
    </div>
  );
};

export default ProjectHeader;
